import ArrowLeft from 'assets/images/sidebar/left.svg'
import { useDispatch } from 'react-redux'
import {
    toggleLogoutModal,
    toggleSideBar,
    toggleSupportModal,
} from 'store/redux/sidebar'
import { sideBarItems } from '../utilities'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import useSetShare from 'utilities/hooks/share/useSetShare'
import { FiGift } from 'react-icons/fi'
import { APP_VERSION, openWhatsNew } from 'modules/whatsNew'

export default function SideBarItems() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const stringifyUser = localStorage.getItem('profile')
    const user: IAuthProfileData | null =
        stringifyUser && JSON.parse(stringifyUser)
    const { handleShareButton } = useSetShare()
    useEffect(() => {
        if (!user) {
            // A missing profile means the cache is incomplete, not that the
            // session is invalid — so send them through the normal profile
            // step rather than destroying a perfectly good login. Startup
            // (utilities/session) normally fills this in before any render;
            // this is the backstop for when that fetch failed.
            navigate('/auth/profile')
        }
    }, [user])
    return (
        <>
            <div className=" mx-4 w-[250px]">
                {user && (
                    <>
                        <div
                            className=" w-full flex justify-end"
                            onClick={() =>
                                dispatch(toggleSideBar({ isOpen: false }))
                            }
                        >
                            <img
                                src={ArrowLeft}
                                alt="arrow"
                                className=" cursor-pointer"
                            />
                        </div>
                        <div className=" mt-2 bg-header-bg p-4 rounded-lg text-center w-1/3">
                            <p className=" text-green-1 text-2xl">
                                {user.first_name[0]}
                            </p>
                        </div>
                        <p className=" mt-2 mb-1 text">
                            {user.first_name} {user.last_name}
                        </p>
                        <p className="">{`0${user.phone_number.slice(3)}`}</p>
                        <hr className=" w-full text-green-1 my-2 " />
                        {sideBarItems.map((item) => (
                            <div
                                className=" flex my-3 cursor-pointer"
                                onClick={() => {
                                    item.id === 13
                                        ? dispatch(
                                              toggleLogoutModal({
                                                  isOpenLogoutModal: true,
                                              })
                                          )
                                        : item.id === 5
                                        ? dispatch(
                                              toggleSupportModal({
                                                  isOpenSupportModal: true,
                                                  source: 'sidebar',
                                              })
                                          )
                                        : item.id === 9
                                        ? handleShareButton()
                                        : navigate(item.route)
                                }}
                                key={item.id}
                            >
                                <img
                                    src={item.icon}
                                    alt="sidebar-items"
                                    className=" mt-auto h-5 w-5 text-green-1"
                                />
                                <p className=" text-sm mr-2">{item.text}</p>
                            </div>
                        ))}
                        {/* The sidebar closes on any tap inside it, so this
                            only has to open the sheet. */}
                        <button
                            type="button"
                            onClick={openWhatsNew}
                            className="mx-auto mt-2 flex items-center gap-1.5 rounded-full bg-brand-soft px-3 py-1 text-xs text-brand-deep"
                        >
                            <FiGift size={13} />
                            <span>
                                نسخهٔ{' '}
                                <bdi dir="ltr">
                                    {APP_VERSION.replace(
                                        /\d/g,
                                        (d) => '۰۱۲۳۴۵۶۷۸۹'[Number(d)]
                                    )}
                                </bdi>
                            </span>
                            <span className="text-brand-strong">· تازه‌ها</span>
                        </button>
                    </>
                )}
            </div>
        </>
    )
}
